import { atomWithReset } from 'jotai/utils';

export const sidebarAtom = atomWithReset<{
  collapseButtonColor: 'white' | 'primary';
}>({
  collapseButtonColor: 'primary',
});
